<template>
  <div class="citySelect">
    <van-sticky>
      <div
        class="citySelectNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">城市选择</span>
      </div>
    </van-sticky>
    <div class="content">
      <div
        class="item"
        v-for="(item, index) in dataList"
        :key="index"
        @click="toDetails(item.id, (index + 6) % 5)"
      >
        <div>
          <img
            v-if="(index + 6) % 5 == 1"
            src="./../../../assets/decoration/citySelect1.png"
            alt=""
          />
          <img
            v-if="(index + 6) % 5 == 2"
            src="./../../../assets/decoration/citySelect2.png"
            alt=""
          />
          <img
            v-if="(index + 6) % 5 == 3"
            src="./../../../assets/decoration/citySelect3.png"
            alt=""
          />
          <img
            v-if="(index + 6) % 5 == 4"
            src="./../../../assets/decoration/citySelect4.png"
            alt=""
          />
          <img
            v-if="(index + 6) % 5 == 0"
            src="./../../../assets/decoration/citySelect5.png"
            alt=""
          />
          <span>{{ item.province_and_city }}</span>
        </div>
        <img src="./../../../assets/decoration/right.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      dataList: [],
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.push({
        path: "/decoration/index",
        query: {
          token: JSON.parse(sessionStorage.getItem("token")),
        },
      });
    },
    getData() {
      this.$api.get("decoration/member/city/partner/area/list").then((res) => {
        this.dataList = res.area;
      });
    },
    toDetails(id, index) {
      this.$router.push({
        path: "/decoration/cityPartner/details",
        query: {
          area_id: id,
          type: 1,
          cityPartnerNum: index,
        },
      });
    },
  },
};
</script>
<style lang="less">
.citySelect {
  min-height: 100%;
  background: #f2f2f2;
  .citySelectNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 0 16px;
    padding-bottom: 16px;
    .item {
      margin-top: 12px;
      background: #ffffff;
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 32px 24px;
      div {
        display: flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
        }
        span {
          margin-left: 12px;
          font-size: 16px;
          color: #333333;
        }
      }
      > img {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>